import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useLocale } from "@ncp/i18n";
import { useCreateThread } from "@ncp/assistant-sdk";
import { useWorkspace } from "./workspace-context";

/** Creates a thread in the current workspace and opens it; `initialPrompt` is sent as the first message once the page loads. */
export function useNewChat(): ((assistantKey?: string, initialPrompt?: string, options?: { mode?: "research" }) => void) & { pending: boolean } {
  const navigate = useNavigate();
  const { workspaceKey, defaultAssistant } = useWorkspace();
  const { locale } = useLocale();
  const create = useCreateThread();
  const fn = useCallback(
    (assistantKey?: string, initialPrompt?: string, options?: { mode?: "research" }) => {
      if (!workspaceKey || create.isPending) return;
      const query = initialPrompt ? `?q=${encodeURIComponent(initialPrompt)}${options?.mode ? `&mode=${options.mode}` : ""}` : "";
      create.mutate(
        { workspaceKey, assistantKey: assistantKey ?? defaultAssistant?.key ?? null, locale, surfaceKey: "assistant" },
        { onSuccess: (thread) => navigate(`/chat/${thread.id}${query}`) },
      );
    },
    [workspaceKey, defaultAssistant, locale, create, navigate],
  );
  return Object.assign(fn, { pending: create.isPending });
}
